import { useCallback, useEffect } from 'react'; // skipcq: JS-0128
import PropTypes from 'prop-types';
// Formik
import { Field } from 'formik';
import { CheckboxWithLabel } from 'formik-mui';
// mui
import Grid from '@mui/material/Grid';
// datepicker
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from 'formik-mui-x-date-pickers';

const OobGrid = ({
  handleBlur,
  setFieldTouched,
  setFieldValue,
  values,
  handleChange,
}) => {
  const onChange = useCallback(
    (e) => {
      if (e.target.checked === true) {
        handleBlur(e); // force blur to update validation
        setFieldTouched('oobDate');
      } else {
        setFieldValue('oobDate', null);
      }

      handleChange(e);
    },
    [handleBlur, setFieldTouched, setFieldValue, handleChange],
  );

  const onDateChange = useCallback(
    (value) => {
      // Store the Day.js object directly (or null), not a string
      setFieldValue('oobDate', value);
    },
    [setFieldValue],
  );

  // Convert the initial value from string/Date to Day.js object when it loads
  useEffect(() => {
    if (values?.oobDate && !dayjs.isDayjs(values.oobDate)) {
      // If the value exists and is not already a Day.js object, convert it
      const parsed = dayjs(values.oobDate);
      if (parsed.isValid()) {
        setFieldValue('oobDate', parsed, false); // false = don't validate
      } else {
        setFieldValue('oobDate', null, false);
      }
    }
  }, [values?.oobDate, setFieldValue]);

  if (!values.updateOob) return null;
  return (
    <Grid
      container
      spacing={0}
      sx={{
        p: 0,
        alignItems: "center"
      }}>
      <Grid
        item
        xs={6}
        md={6}
        style={{ paddingLeft: '16px', paddingTop: '16px' }}
      >
        <Field
          component={CheckboxWithLabel}
          type="checkbox"
          Label={{ label: 'Permanently Closed' }}
          name="isOob"
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={6} md={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Field
            component={DatePicker}
            name="oobDate"
            label="Permanently Closed Date"
            format="MM/DD/YYYY"
            disabled={!values || !values.isOob}
            slotProps={{
              textField: {
                variant: 'standard',
                disabled: !values || !values.isOob,
              },
            }}
            onChange={onDateChange}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};

OobGrid.propTypes = {
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
};
export default OobGrid;
